import React, { useEffect, useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import useMobileDetect from 'helpers/mobile-detect'
import { LazyBackgroundImage } from 'components/share/withImages'

import styles from './trainer-event.module.scss'

export default function Index (props) {
  const [image, setImage] = useState('')
  const currentDevice = useMobileDetect()

  const bgImage = 'url(' + image + ') no-repeat top left/ cover #000000'
  useEffect(() => {
    if (currentDevice.isMobile() && currentDevice.width < 768) {
      setImage('/static/images/testimonials/m-trainer-event.png')
    } else {
      setImage('/static/images/bg-trainer-event.jpg')
    }
  }, [currentDevice.width])

  useEffect(() => {
    LazyBackgroundImage({ src: image, alt: 'Placeholder', loaded: currentDevice.width > 0 })
  }, [image])

  return (
    <section className={styles['trainer-event']}>
      <div className='wrapper  lazy-background' style={{ background: bgImage }}>
        <div className='container'>
          <h2 className={`${styles['trainer-event__main-title']} text-center`}>
          the trainer even the champs trust
          </h2>
          <Row>
            <Col xs={12} md={5}>
              <p className={styles['trainer-event__title']}>
              "I don't count calories at all. I don't crave anything. There is nothing missing from my diet."
              </p>
              <span className={styles['trainer-event__author']}>— Ronda Rousey via Cosmopolitan</span>
            </Col>
            <Col xs={12} md={5} className="offset-md-2">
              <p className={styles['trainer-event__title']}>
              "Mike Dolce takes these athletes to another level – just imagine what he can do for you.”
              </p>
              <span className={styles['trainer-event__author']}>— Dana White, UFC President</span>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  )
}
